import React from 'react';
import './MatchResultBox.css';
import { useDispatch } from 'react-redux';
import * as matchActions from '../../../redux/actions/matchActions';
import BlockIcon from '@mui/icons-material/Block';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import constants from '../../../constants/constants';

function MatchResultBox({ result, isAdmin }) {
    const dispatch = useDispatch();

    const sortedSets = result.setPoints
        ? [...result.setPoints].sort((a, b) => Number(a.setNumber) - Number(b.setNumber))
        : [];

    const p1Won = Number(result.playerOne.score) > Number(result.playerTwo.score);

    const renderPlayerRow = (player, isPlayerOne) => {
        const won = isPlayerOne ? p1Won : !p1Won;
        return (
            <div className={`sb-player-row${won ? ' sb-winner-row' : ''}`}>
                <div className={`sb-total${won ? ' sb-total-winner' : ''}`}>{player.score}</div>
                <div className='sb-name'>{player.name}</div>
                <div className='sb-sets'>
                    {sortedSets.map((set) => {
                        const myScore = isPlayerOne ? set.playerOneScore : set.playerTwoScore;
                        const opScore = isPlayerOne ? set.playerTwoScore : set.playerOneScore;
                        const wonSet = Number(myScore) > Number(opScore);
                        return (
                            <span key={set.setNumber} className={`sb-set-score${wonSet ? ' sb-set-won' : ''}`}>
                                {myScore}
                            </span>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div onClick={() => dispatch(matchActions.setSelectedMatch(result))} className='result-box-container'>
            <div className='rb-court-chip'>
                <SportsTennisIcon sx={{ fontSize: 10 }} />
                <span>{result.courtName}</span>
            </div>

            {sortedSets.length > 0 && (
                <div className='sb-header-row'>
                    <div className='sb-total' />
                    <div className='sb-name' />
                    <div className='sb-sets'>
                        {sortedSets.map((set) => (
                            <span key={set.setNumber} className='sb-set-header'>
                                S{set.setNumber}
                            </span>
                        ))}
                    </div>
                </div>
            )}
            {renderPlayerRow(result.playerOne, true)}
            {renderPlayerRow(result.playerTwo, false)}

            {isAdmin && (
                <div className='rb-admin-actions'>
                    <button
                        className='rb-disable-btn'
                        onClick={(e) => {
                            e.stopPropagation();
                            dispatch(matchActions.disableMatch(result.matchId));
                        }}
                    >
                        <BlockIcon fontSize='small' />
                        {constants.ADD_GAME.DISABLE}
                    </button>
                </div>
            )}
        </div>
    );
}

export default MatchResultBox;
